module.exports = __webpack_public_path__ + "static/images/015c69f9f755d104550d84222dd721da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pointer.png
// module id = 1833
// module chunks = 0